module.exports = __webpack_public_path__ + "img/DMTIMS LOGO.819ae007.jpg";